/**
 * Custom Javascript Code for PROfertil menu.
 *
 * @author Eberhard Lauth
 *
 */
( function ( $ ) {

    /* Hide Child pages when not on child page*/
    if($('body').hasClass('page-child')) {
        $('.child-pages-wrapper').show();
    } else {
        $('.child-pages-wrapper').hide();
    }

    /* Menu icon change for PROfertil Hamburger menu */

    $(document).ready(function() {
        $('.topbar-responsive .top-bar-title .profertil-hamburger').addClass('closed');
    });

    $(document).on('toggled.zf.responsiveToggle', function () {
        if ( $('.topbar-responsive .top-bar-title .profertil-hamburger').hasClass('closed') ) {
            $('.topbar-responsive .top-bar-title .profertil-hamburger').removeClass('closed').addClass('opened');
            $('body').removeClass('closed').addClass('opened');
            $('a.profertil-hamburger i.material-icons').removeClass('md-menu').addClass('md-close');
        } else {
            $('.topbar-responsive .top-bar-title .profertil-hamburger').removeClass('opened').addClass('closed');
            $('body').removeClass('opened').addClass('closed');
            $('a.profertil-hamburger i.material-icons').removeClass('md-close').addClass('md-menu');
        }
    });

} )( jQuery );